module.exports = __webpack_public_path__ + "static/media/success-green.054c0e1b.svg";